"use client";

import React from "react";
import DashboardHeaderCard from "@/components/common/DashboardHeaderCard";
import { User, Truck } from "lucide-react";

const DashboardHeader = ({ data }) => {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3 w-full">
      <DashboardHeaderCard
        name="ACTIVE TRIPS"
        count={data?.total_active_trips?.toString() || "0"}
        icon={<Truck size={18} color="hsl(var(--primary))" />}
      />

      <DashboardHeaderCard
        name="TOTAL USERS"
        count={data?.total_users?.toString() || "0"}
        icon={<User size={18} color="hsl(var(--primary))" />}
      />

      <DashboardHeaderCard
        name="TOTAL VEHICLES"
        count={data?.total_vehicles?.toString() || "0"}
        icon={<Truck size={18} color="hsl(var(--primary))" />}
      />

      <DashboardHeaderCard
        name="TOTAL DRIVERS"
        count={data?.total_drivers?.toString() || "0"}
        icon={<User size={18} color="hsl(var(--primary))" />}
      />
    </div>
  );
};

export default DashboardHeader;